"use client";

import { ErrorPage } from "@/app/global-error";
import { Button } from "@/components/ui/button";
import { useRouter } from "next/navigation";

const RootNotFoundPage = () => {
  const router = useRouter();
  return (
    <ErrorPage
      errorCode="404"
      actionButtonElement={
        <Button variant="primary" onClick={() => router.replace("/")}>
          ホーム
        </Button>
      }
    />
  );
};

export default RootNotFoundPage;
